export default async function ({ $auth, redirect, route, store, app }) {
  // 如果有 appAuth 參數，則將 appAuth 設定為使用者 token
  // 如參數為 ?appAuth=，則登出，如果為 ?appAuth，則維持登入狀態
  // isNewAuth 參數為 true 時，代表使用新版驗證方式
  const { appAuth, isNewAuth } = route.query
  try {
    if (appAuth) {
      if (isNewAuth !== 'true') {
        // 舊版驗證方式
        return await $auth.setUserToken(appAuth)
      }

      // 新版驗證方式
      // 短token換取長token
      const { Data } = await app.$axios.$post(`/api/Authentication/ECToken/Exchange?oneTimeCode=${encodeURIComponent(appAuth)}`)
      const { AccessToken, RefreshToken } = Data

      // 將 EC token 設定到 $auth
      await $auth.setUserToken(AccessToken)
      $auth.$storage.setUniversal('refresh_token', RefreshToken)
      store.commit('setLoginFrom', 'App')
    }

    if (appAuth === '') {
      await store.dispatch('logOut')
    }
  } catch (err) {
    console.log(err)
    redirect(`/auth/login?redirect=${route.path}`)
  }
}
